import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import { FormLicenseFeature } from "./FormLicenseFeature";

export function NewLicenseFeature({ ...props }) {

   return (
      <CadastroContainer>
         <FormLicenseFeature type="cadastro" />
      </CadastroContainer>
   );
}